export class UserRoleModel{
    UserRoleId? :number
    RoleId? :number
    UserId? :number
    CreatedDate? :Date
    CreatedBy? :number
    ModifiedDate? :Date
    ModifiedBy? :number
}
